import createIcon from '@/lib/create-icon'

const BoxingIcon = createIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 46 46'
    fill='none'
  >
    <path
      fill='none'
      d='M11.4642 21.5537C11.2974 26.7718 17.4462 33.2035 23.2115 35.2254M11.4642 21.5537C10.8804 22.5555 4.91807 27.3353 4.81382 29.36C4.30864 33.3808 11.1398 40.9344 16.4068 41.1922C18.3737 41.4713 21.102 38.1614 23.8675 35.7023C25.3907 34.3478 27.5859 34.0346 36.3726 31.854C39.5612 31.2999 43.3919 25.7998 37.7132 21.1377M11.4642 21.5537C13.2433 17.3348 16.3189 9.17877 22.3507 5.95798C24.8002 4.56624 31.1624 3.28479 37.3965 9.21151C39.5413 11.0153 43.259 14.9664 39.7987 19.5187C37.4916 22.2074 34.0033 21.4291 33.6644 26.0791'
      stroke='url(#paint0_linear_5304_2357)'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M11.4642 21.5537C11.2974 26.7718 17.4462 33.2035 23.2115 35.2254M11.4642 21.5537C10.8804 22.5555 4.91807 27.3353 4.81382 29.36C4.30864 33.3808 11.1398 40.9344 16.4068 41.1922C18.3737 41.4713 21.102 38.1614 23.8675 35.7023C25.3907 34.3478 27.5859 34.0346 36.3726 31.854C39.5612 31.2999 43.3919 25.7998 37.7132 21.1377M11.4642 21.5537C13.2433 17.3348 16.3189 9.17877 22.3507 5.95798C24.8002 4.56624 31.1624 3.28479 37.3965 9.21151C39.5413 11.0153 43.259 14.9664 39.7987 19.5187C37.4916 22.2074 34.0033 21.4291 33.6644 26.0791'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M11.4642 21.5537C11.2974 26.7718 17.4462 33.2035 23.2115 35.2254M11.4642 21.5537C10.8804 22.5555 4.91807 27.3353 4.81382 29.36C4.30864 33.3808 11.1398 40.9344 16.4068 41.1922C18.3737 41.4713 21.102 38.1614 23.8675 35.7023C25.3907 34.3478 27.5859 34.0346 36.3726 31.854C39.5612 31.2999 43.3919 25.7998 37.7132 21.1377M11.4642 21.5537C13.2433 17.3348 16.3189 9.17877 22.3507 5.95798C24.8002 4.56624 31.1624 3.28479 37.3965 9.21151C39.5413 11.0153 43.259 14.9664 39.7987 19.5187C37.4916 22.2074 34.0033 21.4291 33.6644 26.0791'
      stroke='url(#paint1_radial_5304_2357)'
      strokeOpacity='0.6'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <defs>
      <linearGradient
        id='paint0_linear_5304_2357'
        x1='4.78735'
        y1='4.78809'
        x2='46.4233'
        y2='33.7049'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_5304_2357'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(22.9996 41.2087) scale(18.2122 18.5467)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
    </defs>
  </svg>,
  'BoxingIcon'
)

export default BoxingIcon
